<template>
  <div>
    <div v-if="trackingLinkList!= null">
      <div class="row">
        <div class="col-md-8">
          <h5 style="text-transform: uppercase; font-size:16px;margin-top: 15px;">Tracking Links:</h5>
        </div>
        <div class="col-md-4">
          <p-button
            @click="showAddTrackingLinkModal"
            round
            outline
            type="info"
            size="sm"
            style="float: right;"
          >+ New Tracking Link</p-button>
        </div>
      </div>

      <div class="card">
        <div class="row">
          <div v-if="trackingLinkList.length > 0" style="padding: 20px;">
            <div class="col-md-12">
              <template>
                <el-table
                  :data="trackingLinkList"
                  class="table-striped"
                  stripe
                  border
                  style="width: 100%"
                >
                  <el-table-column label="Link" width="350">
                    <template slot-scope="props">
                      <div
                        style=" text-transform: uppercase; font-weight: bold; "
                      >{{props.row.data.name}}</div>
                      <span
                        style="overflow-wrap: break-word; font-size:12px; "
                      >{{props.row.trackingUrl}}</span>
                    </template>
                  </el-table-column>

                  <el-table-column label="Short Link" width="225">
                    <template slot-scope="props">
                      <div
                        style="overflow-wrap: break-word; font-size:12px; "
                      >{{props.row.data.shortLink}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Date Added" width="150">
                    <template slot-scope="props">
                      <div style=" ">{{props.row.dateAddedString}}</div>
                    </template>
                  </el-table-column>

                  <el-table-column label="Edit" width="300">
                    <template slot-scope="props">
                      <p-button
                        round
                        icon
                        outline
                        type="info"
                        @click="$router.push(`/tools/tracking-links/analytics/${props.row.data._id}`)"
                        style="margin:3px;"
                      >
                        <i class="far fa-chart-bar"></i>
                      </p-button>
                      <p-button
                        round
                        icon
                        outline
                        type="info"
                        @click="showTrackingLinkEditModal(props.row.data._id)"
                        style="margin:3px;"
                      >
                        <i class="far fa-edit"></i>
                      </p-button>

                      <p-button
                        round
                        icon
                        outline
                        type="info"
                        @click="showTrackingLinkCopyModal(props.row.data._id)"
                        style="margin:3px;"
                      >
                        <i class="far fa-copy"></i>
                      </p-button>
                      <p-button
                        round
                        icon
                        outline
                        type="info"
                        @click="showTrackingLinkArchiveAlert(props.row.data._id)"
                        style="margin:3px;"
                      >
                        <i class="far fa-trash-alt"></i>
                      </p-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </div>
          </div>
          <div v-else style="padding:25px;">No Links</div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="lds-dual-ring"></div>
    </div>

    <modal :show.sync="addTrackingLinkModal" type="notice" class="modal-custom">
      <div>
        <h5 class="card-title" style="margin:0px;">Add Tracking Link:</h5>
        <hr />
        <div
          class="alert alert-dismissible fade show"
          :class="alertType"
          v-if="addTrackingLinkAlert==true"
          style="width:100%"
        >
          <div v-for="alert in addTrackingLinkErrors" :key="alert" style="width:100%">
            <button
              type="button"
              aria-hidden="true"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <i class="nc-icon nc-simple-remove"></i>
            </button>

            <span>{{alert}}</span>
          </div>
        </div>

        <!--<div class="typography-line-custom" style="clear:both;">
              <span>Business Name:</span>
              <p>{{campaignData.business.businessName}}</p>
        </div>-->
        <div class="typography-line-custom">
          <p>
            <span>Tracking Link Description:</span>
            <fg-input
              placeholder="e.g. Main Product Page or Homepage"
              v-model="newLinkName"
              name="linkName"
              type="text"
              required
            ></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>Landing Page URL:</span>
            <fg-input
              placeholder="e.g. http://brandco.com/landingpage"
              v-model="newLandingPage"
              name="landingPage"
              type="text"
              required
            ></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_campaign:</span>
            <fg-input placeholder v-model="newUtmCampaign" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_source:</span>
            <fg-input placeholder v-model="newUtmSource" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_medium:</span>
            <fg-input placeholder v-model="newUtmMedium" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_term:</span>
            <fg-input placeholder v-model="newUtmTerm" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_content:</span>
            <fg-input placeholder v-model="newUtmContent" type="text" required></fg-input>
          </p>
        </div>

        <div class="row">
          <p-button color="success" class="mr-4" @click="trackingLinkCreate">SAVE</p-button>
        </div>
      </div>
    </modal>
    <modal :show.sync="editTrackingLinkModal" type="notice" class="modal-custom">
      <div>
        <h5 class="card-title" style="margin:0px;">Edit Tracking Link:</h5>
        <hr />
        <div
          class="alert alert-dismissible fade show"
          :class="alertType"
          v-if="addTrackingLinkAlert==true"
          style="width:100%"
        >
          <div v-for="alert in addTrackingLinkErrors" :key="alert" style="width:100%">
            <button
              type="button"
              aria-hidden="true"
              class="close"
              data-dismiss="alert"
              aria-label="Close"
            >
              <i class="nc-icon nc-simple-remove"></i>
            </button>

            <span>{{alert}}</span>
          </div>
        </div>

        <!--<div class="typography-line-custom" style="clear:both;">
              <span>Business Name:</span>
              <p>{{campaignData.business.businessName}}</p>
        </div>-->
        <div class="typography-line-custom">
          <p>
            <span>Tracking Link Description:</span>
            <fg-input
              placeholder="e.g. Main Product Page or Homepage"
              v-model="editLinkName"
              name="linkName"
              type="text"
              required
            ></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>Landing Page URL:</span>
            <fg-input
              placeholder="e.g. http://brandco.com/landingpage"
              v-model="editLandingPage"
              name="landingPage"
              type="text"
              required
            ></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_campaign:</span>
            <fg-input placeholder v-model="editUtmCampaign" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_source:</span>
            <fg-input placeholder v-model="editUtmSource" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_medium:</span>
            <fg-input placeholder v-model="editUtmMedium" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_term:</span>
            <fg-input placeholder v-model="editUtmTerm" type="text" required></fg-input>
          </p>
        </div>
        <div class="typography-line-custom">
          <p>
            <span>utm_content:</span>
            <fg-input placeholder v-model="editUtmContent" type="text" required></fg-input>
          </p>
        </div>

        <div class="row">
          <p-button color="success" class="mr-4" @click="trackingLinkUpdate">SAVE</p-button>
        </div>
      </div>
    </modal>
    <modal
      :show.sync="archiveTrackingLinkConfirmAlert"
      :show-close="false"
      :show-header="false"
      type="mini"
      class="modal-custom"
    >
      <p style="text-align:center;">Confirm Delete Tracking Link?</p>
      <div style="text-align:center;">
        <div style="margin-left:auto; margin-right:auto;">
          <p-button
            round
            type="danger"
            text
            @click="trackingLinkArchive(currentEditLink[0].data._id)"
            style="margin: 10px;"
            size="sm"
          >Yes, Delete</p-button>
          <p-button
            round
            text
            @click="archiveTrackingLinkConfirmAlert=false"
            style="margin: 10px"
            size="sm"
          >Cancel</p-button>
        </div>
      </div>
    </modal>
  </div>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import moment from "moment";
import {
  trackingLinkCreateApi,
  userLoadApi,
  userRelatedProfilesApi,
  trackingLinkReadListApi,
  trackingLinkUpdateApi,
} from "@/config/appSettings";
import {
  TimeLine,
  TimeLineItem,
  Badge,
  Modal,
} from "src/components/UIComponents";
import { Select, Option } from "element-ui";
import { mapGetters, mapActions } from "vuex";
import Datepicker from "vuejs-datepicker";
export default {
  components: {
    TimeLine,
    TimeLineItem,
    Badge,
    Modal,
    [Select.name]: Select,
    [Option.name]: Option,
    Datepicker,
  },
  data: () => ({
    auth: null,
    campaignStartForm: null,
    loadingOverlay: false,
    loadingOverlayText: null,
    campaign: null,
    email: null,

    alertMsg: null,
    showAlert: false,
    alertType: null,
    displayAlert: false,
    saveOverlay: null,

    addTrackingLinkModal: false,
    addTrackingLinkAlert: false,
    addTrackingLinkErrors: [],
    newLandingPage: null,
    newLinkName: null,
    newUtmCampaign: null,
    newUtmSource: null,
    newUtmMedium: null,
    newUtmTerm: null,
    newUtmContent: null,
    editLandingPage: null,
    editLinkName: null,
    editUtmCampaign: null,
    editUtmSource: null,
    editUtmMedium: null,
    editUtmTerm: null,
    editUtmContent: null,
    editTrackingLinkModal: false,
    trackingLinkList: null,
    archiveTrackingLinkConfirmAlert: false,
    currentEditLink: null,

    trackingLinkModel: {
      newLandingPage: null,
      newLinkName: null,
      newUtmCampaign: null,
      newUtmSource: null,
      newUtmMedium: null,
      newUtmTerm: null,
      newUtmContent: null,
    },
    trackingLinkModelValidations: {
      landingPage: {
        required: true,
        url: { require_protocol: true },
      },
      linkName: {
        required: true,
      },
    },
    linkData: null,
    isTeam: null,
    isClient: null,
    isInfluencer: null,
    relatedProfiles: null,
    clientId: null,
  }),
  name: "TrackingLinks",
  computed: { ...mapGetters(["profileStore", "relatedProfileStore"]) },
  methods: {
    getError(fieldName) {
      //console.log("ERRORS FOUND: ", this.errors.first(fieldName));
      try {
        return this.errors.first(fieldName);
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    validate() {
      this.$validator.validateAll().then((isValid) => {
        try {
          //console.log("CHECKING IS VALID:", isValid);
          //console.log("CHECKING REGISTER FORM: ", this.registerForm);
          this.$emit("on-submit", this.registerForm, isValid);
        } catch (err) {
          console.log("THERE WAS AN ERROR:", err);
        }
      });
    },
    async setProfileType() {
      if (this.profileStore.isTeam === true) {
        this.isTeam = true;
      }

      console.log("PROFILE STORE DASHBOARD:", this.profileStore);
      if (this.profileStore !== false) {
        try {
          if (this.profileStore.profileTypes.length > 0) {
            if (this.profileStore.profileTypes.indexOf("influencer") !== -1) {
              this.isInfluencer = true;
            }
            if (this.profileStore.profileTypes.indexOf("client") !== -1) {
              this.isClient = true;
            }
          }
        } catch (err) {
          console.log("ERROR:", err);
        }
      }

      // IF NOT LOADED YET LOAD DIRECTLY TO SET PROFILE TYPE

      if (this.profileStore === false) {
        let profileData = await axios.get(`${userLoadApi}${this.auth}`);
        console.log("PROFILE DATA MAIN:", profileData.data);
        if (profileData.data.success === true) {
          if (profileData.data.result.isTeam === true) {
            this.isTeam = true;
          }
          try {
            if (profileData.data.result.profileTypes.length > 0) {
              if (
                profileData.data.result.profileTypes.indexOf("influencer") !==
                -1
              ) {
                this.isInfluencer = true;
              }
              if (
                profileData.data.result.profileTypes.indexOf("client") !== -1
              ) {
                this.isClient = true;
              }
            }
          } catch (err) {
            console.log("ERROR:", err);
          }
        }
      }
    },
    async showAddTrackingLinkModal() {
      try {
        this.addTrackingLinkErrors = [];
        this.addTrackingLinkAlert = false;
        this.addTrackingLinkModal = true;
        this.newLandingPage = null;
        this.newLinkName = null;
        this.newUtmCampaign = null;
        this.newUtmSource = null;
        this.newUtmMedium = null;
        this.newUtmTerm = null;
        this.newUtmContent = null;
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async showEditCampaignModal(linkId) {
      this.editCampaignDetailsModal = true;
      this.editCampaignAlertMsg = null;
      this.editCampaignAlertType = null;
      this.editCampaignAlert = false;
    },

    async showTrackingLinkEditModal(linkId) {
      this.editTrackingLinkModal = true;
      this.editTrackingLinkAlertMsg = null;
      this.editTrackingLinkAlertType = null;
      this.editTrackingLinkAlert = false;

      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x.data._id == linkId;
      });
      console.log("EDIT LINK DATA:", this.currentEditLink);
      if (this.currentEditLink.length > 0) {
        this.editLandingPage = this.currentEditLink[0].data.landingPage;
        this.editLinkName = this.currentEditLink[0].data.name;
        this.editUtmCampaign = this.currentEditLink[0].data.utmCampaign;
        this.editUtmSource = this.currentEditLink[0].data.utmSource;
        this.editUtmMedium = this.currentEditLink[0].data.utmMedium;
        this.editUtmTerm = this.currentEditLink[0].data.utmTerm;
        this.editUtmContent = this.currentEditLink[0].data.utmContent;
      }
    },
    async showTrackingLinkCopyModal(linkId) {
      this.addTrackingLinkModal = true;
      this.editTrackingLinkAlertMsg = null;
      this.editTrackingLinkAlertType = null;
      this.editTrackingLinkAlert = false;

      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x.data._id == linkId;
      });
      console.log("EDIT LINK DATA:", this.currentEditLink);
      if (this.currentEditLink.length > 0) {
        this.newLandingPage = this.currentEditLink[0].data.landingPage;
        this.newLinkName = `Copy of ${this.currentEditLink[0].data.name}`;
        this.newUtmCampaign = this.currentEditLink[0].data.utmCampaign;
        this.newUtmSource = this.currentEditLink[0].data.utmSource;
        this.newUtmMedium = this.currentEditLink[0].data.utmMedium;
        this.newUtmTerm = this.currentEditLink[0].data.utmTerm;
        this.newUtmContent = this.currentEditLink[0].data.utmContent;
      }
    },
    async showTrackingLinkArchiveAlert(linkId) {
      this.archiveTrackingLinkConfirmAlert = true;

      this.currentEditLink = this.trackingLinkList.filter((x) => {
        return x.data._id == linkId;
      });
    },
    async trackingLinkCreate() {
      try {
        console.log("CREATING TRACKING LINK");
        this.addTrackingLinkErrors = [];
        if (
          this.newLinkName == null ||
          typeof this.newLinkName == "undefined"
        ) {
          this.addTrackingLinkErrors.push("Tracking link name required.");
        }
        if (
          this.newLandingPage == null ||
          typeof this.newLandingPage == "undefined"
        ) {
          this.addTrackingLinkErrors.push("Landing page required.");
        }
        if (this.addTrackingLinkErrors.length > 0) {
          this.addTrackingLinkAlert = true;
          this.alertType = "alert-danger";
          return;
        }
        let newTrackingLink = {};
        if (this.isClient == true) {
          if (
            typeof this.profileStore.relatedClients[0].clientId !== "undefined"
          ) {
            newTrackingLink.client = this.profileStore.relatedClients[0].clientId;
          }
        }
        else if (this.isInfluencer == true) {
          if (
            typeof this.profileStore.relatedInfluencers[0].influencerId !==
            "undefined"
          ) {
            newTrackingLink.influencer = this.profileStore.relatedInfluencers[0].influencerId;
          }
        }
        else{
          this.addTrackingLinkAlert = true;
          this.alertType = "alert-danger";
          this.addTrackingLinkErrors.push("Invalid Account");
          return 
        }

        newTrackingLink.landingPage = this.newLandingPage;
        newTrackingLink.usertoken = this.auth;
        newTrackingLink.name = this.newLinkName;
        if (
          this.newUtmSource !== null &&
          typeof this.newUtmSource !== "undefined"
        ) {
          newTrackingLink.utmSource = this.newUtmSource;
        }
        if (
          this.newUtmCampaign !== null &&
          typeof this.newUtmCampaign !== "undefined"
        ) {
          newTrackingLink.utmCampaign = this.newUtmCampaign;
        }

        if (
          this.newUtmMedium !== null &&
          typeof this.newUtmMedium !== "undefined"
        ) {
          newTrackingLink.utmMedium = this.newUtmMedium;
        }

        if (
          this.newUtmTerm !== null &&
          typeof this.newUtmTerm !== "undefined"
        ) {
          newTrackingLink.utmTerm = this.newUtmTerm;
        }

        if (
          this.newUtmContent !== null &&
          typeof this.newUtmContent !== "undefined"
        ) {
          newTrackingLink.utmContent = this.newUtmContent;
        }

        console.log("SENDING:", newTrackingLink);
        let newTrackingLinkResponse = await axios.post(
          trackingLinkCreateApi,
          newTrackingLink
        );
        console.log("NEW TRACKING LINK RESPONSE:", newTrackingLinkResponse);
        if (newTrackingLinkResponse.data.success == true) {
          this.addTrackingLinkModal = false;
          await this.loadTrackingLinks();
        }
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async trackingLinkUpdate() {
      console.log("CREATING TRACKING LINK");
      this.editTrackingLinkErrors = [];
      if (
        this.editLinkName == null ||
        typeof this.editLinkName == "undefined"
      ) {
        this.editTrackingLinkErrors.push("Tracking link name required.");
      }
      if (
        this.editLandingPage == null ||
        typeof this.editLandingPage == "undefined"
      ) {
        this.editTrackingLinkErrors.push("Landing page required.");
      }
      if (this.editTrackingLinkErrors.length > 0) {
        this.editTrackingLinkAlert = true;
        this.alertType = "alert-danger";
        return;
      }
      let updateTrackingLink = {};
      updateTrackingLink.link = this.currentEditLink[0].data._id;

      updateTrackingLink.landingPage = this.editLandingPage;
      updateTrackingLink.usertoken = this.auth;
      updateTrackingLink.name = this.editLinkName;
      if (
        this.editUtmSource !== null &&
        typeof this.editUtmSource !== "undefined"
      ) {
        updateTrackingLink.utmSource = this.editUtmSource;
      }
      if (
        this.editUtmCampaign !== null &&
        typeof this.editUtmCampaign !== "undefined"
      ) {
        updateTrackingLink.utmCampaign = this.editUtmCampaign;
      }

      if (
        this.editUtmMedium !== null &&
        typeof this.editUtmMedium !== "undefined"
      ) {
        updateTrackingLink.utmMedium = this.editUtmMedium;
      }

      if (
        this.editUtmTerm !== null &&
        typeof this.editUtmTerm !== "undefined"
      ) {
        updateTrackingLink.utmTerm = this.editUtmTerm;
      }

      if (
        this.editUtmContent !== null &&
        typeof this.editUtmContent !== "undefined"
      ) {
        updateTrackingLink.utmContent = this.editUtmContent;
      }

      console.log("SENDING:", updateTrackingLink);
      let updateTrackingLinkResponse = await axios.post(
        trackingLinkUpdateApi,
        updateTrackingLink
      );
      console.log("NEW TRACKING LINK RESPONSE:", updateTrackingLinkResponse);
      if (updateTrackingLinkResponse.data.success == true) {
        this.currentEditLink = null;
        this.editTrackingLinkModal = false;
        await this.loadTrackingLinks();
      }
    },
    async trackingLinkArchive(linkId) {
      //console.log("CREATING TRACKING LINK");

      let archiveTrackingLink = {};
      archiveTrackingLink.link = linkId;

      archiveTrackingLink.status = "archived";
      archiveTrackingLink.usertoken = this.auth;

      //console.log("SENDING:", archiveTrackingLink);
      let archiveTrackingLinkResponse = await axios.post(
        trackingLinkUpdateApi,
        archiveTrackingLink
      );
      //console.log("NEW TRACKING LINK RESPONSE:", archiveTrackingLinkResponse);
      if (archiveTrackingLinkResponse.data.success == true) {
        this.currentEditLink = null;
        this.archiveTrackingLinkConfirmAlert = false;
        await this.loadTrackingLinks();
      }
    },
    async loadTrackingLinks() {
      let trackingLinkListUrl;
      if (this.isClient == true) {
        let clientId = this.profileStore.relatedClients[0].clientId;
        console.log("CLIENT ID:", clientId);
        trackingLinkListUrl = `${trackingLinkReadListApi}/?usertoken=${this.auth}&client=${clientId}`;
      }
      if (this.isTeam == true) {
        let clientId = this.profileStore.relatedClients[0].clientId;
        console.log("CLIENT ID:", clientId);
        trackingLinkListUrl = `${trackingLinkReadListApi}/?usertoken=${this.auth}&client=${clientId}`;
      }
      if (this.isInfluencer == true) {
        let influencerId = this.profileStore.relatedInfluencers[0].influencerId;
        console.log("INFLUENCER ID:", influencerId);
        trackingLinkListUrl = `${trackingLinkReadListApi}/?usertoken=${this.auth}&influencer=${influencerId}`;
      }
      let trackingLinkListResponse = await axios.get(trackingLinkListUrl);
      console.log("TRACKING LINK LIST:", trackingLinkListResponse.data);

      if (trackingLinkListResponse.data.success == true) {
        this.trackingLinkList = trackingLinkListResponse.data.result.map(
          (x) => {
            let thisLink = {};
            let linkUrl = x.landingPage;
            let utmCodes = [];
            let utmString;
            if (
              typeof x.utmCampaign != "undefined" &&
              x.utmCampaign.trim() !== ""
            ) {
              utmCodes.push(`utm_campaign=${x.utmCampaign}`);
            }
            if (
              typeof x.utmSource != "undefined" &&
              x.utmSource.trim() !== ""
            ) {
              utmCodes.push(`utm_source=${x.utmSource}`);
            }
            if (
              typeof x.utmMedium != "undefined" &&
              x.utmMedium.trim() !== ""
            ) {
              utmCodes.push(`utm_medium=${x.utmMedium}`);
            }
            if (typeof x.utmTerm != "undefined" && x.utmTerm.trim() !== "") {
              utmCodes.push(`utm_term=${x.utmTerm}`);
            }
            if (
              typeof x.utmContent != "undefined" &&
              x.utmContent.trim() !== ""
            ) {
              utmCodes.push(`utm_content=${x.utmContent}`);
            }
            if (utmCodes.length > 1) {
              utmString = utmCodes.join("&");
              linkUrl = `${linkUrl}/?${utmString}`;
            }
            if (utmCodes.length === 1) {
              utmString = utmCodes[0];
              linkUrl = `${linkUrl}/?${utmString}`;
            }
            thisLink.dateAddedString = moment
              .unix(x.dateAdded)
              .format("M/D/YY");
            thisLink.trackingUrl = linkUrl;

            thisLink.data = x;
            return thisLink;
          }
        );
        console.log("FINAL TRACKING LINK:", this.trackingLinkList);
      }
    },
    async getRelatedProfiles() {
      //console.log("RELATED PROFILES:", this.relatedProfileStore);

      if (this.isTeam !== true) {
        if (this.relatedProfileStore === false) {
          let relatedProfileResponse = await axios.get(
            `${userRelatedProfilesApi}/?usertoken=${this.auth}`
          );
          this.relatedProfiles = relatedProfileResponse.data.result;
        } else {
          this.relatedProfiles = this.relatedProfileStore;
        }
        console.log("RELATED PROFILE SECOND CHECK: ", this.relatedProfiles);
      }
    },
    async campaignDateFormat(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    },

    toggleForm() {
      this.showForm = true;
      this.showIntro = false;
    },

    percentDollarString(transactionType) {
      try {
        if (transactionType === "percent") {
          return "% percent";
        }
        if (transactionType === "dollars") {
          return "$ dollars";
        }
        return "";
      } catch (err) {
        console.log("THERE WAS AN ERROR:", err);
      }
    },
    async loadPageContent() {
      await this.setProfileType();
      await this.getRelatedProfiles();
      console.log("RELATED PROFILES:", this.relatedProfiles);
      this.loadTrackingLinks();
    },
  },

  mounted() {
    this.loadingOverlay = true;
    this.loadingOverlayText = "Loading...";
    this.auth = firebase.auth().currentUser.uid;

    this.loadPageContent();
  },
};
</script>

<style scoped>
.field-bg {
  background-color: white;
  margin: 10px;
}
</style>